import { render } from "./ReservationHero.vue?vue&type=template&id=79089c4a&scoped=true"
const script = {}

import "./ReservationHero.vue?vue&type=style&index=0&id=79089c4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79089c4a"]])

export default __exports__